import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import debounce from 'lodash.debounce';
import { Input } from 'antd';

import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

export const SearchBar = ({ t, size = '', placeholder }) => {
  let [searchParams, setSearchParams] = useSearchParams();

  const handleSearch = useCallback(
    ({ target: { value } }) => {
      if (!value) {
        setSearchParams({});
      } else {
        setSearchParams({ search: value });
      }
    },
    [setSearchParams],
  );

  const onChangeDebounce = useMemo(() => {
    return debounce(handleSearch, 500);
  }, [handleSearch]);

  return (
    <div className={styles.search}>
      <Input
        size={size ? size : null}
        prefix={<CroplerIcon name="search" />}
        allowClear
        className={styles.searchInput}
        placeholder={placeholder ? placeholder : t('labels.search')}
        onChange={onChangeDebounce}
        defaultValue={searchParams.get('search')}
      />
    </div>
  );
};
